import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { merge, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { SMS_NOTIFICATION_ACTION_TYPE, SmsNotificationSettingsAction } from "./sms-notification-settings.action";
import { SMS_NOTIFICATIONS_MESSAGE_CODES } from "./sms-notification-settings.const";
import { SmsNotificationSettings } from "./sms-notification-settings.model";
import { SmsNotificationSettingsService } from "./sms-notification-settings.service";

@Injectable()
/**
 * @deprecated - [fabric-deprecated] - Use SmsNotificationSettingsService from app-account mfe instead
 */
export class SmsNotificationSettingsEffect {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetSmsNotificationSettings) instead
	 */
	get$ = createEffect(() =>
		this.actions$.pipe(
			ofType(SMS_NOTIFICATION_ACTION_TYPE.getAll),
			switchMap(() =>
				this.service.getAll().pipe(
					map((smsNotifications) => this.action.getAllSuccess(smsNotifications)),
					catchError((response: AppError) => of(this.action.getAllFail(response)))
				)
			)
		)
	);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.UpdateSmsNotificationSettings) instead
	 */
	update$ = createEffect(() =>
		this.actions$.pipe(
			ofType(SMS_NOTIFICATION_ACTION_TYPE.update),
			map((x: ActionWithPayload<SmsNotificationSettings>) => x.payload),
			switchMap((smsNotifications) =>
				this.service.update(smsNotifications).pipe(
					map(() => this.action.updateSuccess(smsNotifications)),
					catchError((response: AppError) => of(this.action.updateFail(response)))
				)
			)
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[SMS_NOTIFICATION_ACTION_TYPE.getAllFail]: SMS_NOTIFICATION_ACTION_TYPE.getAll,
				[SMS_NOTIFICATION_ACTION_TYPE.updateFail]: SMS_NOTIFICATION_ACTION_TYPE.update,
			}),
			this.messageService.mapClearByContext$({
				[SMS_NOTIFICATION_ACTION_TYPE.getAll]: SMS_NOTIFICATION_ACTION_TYPE.getAll,
				[SMS_NOTIFICATION_ACTION_TYPE.update]: SMS_NOTIFICATION_ACTION_TYPE.update,
			}),
			this.messageService.map$({
				[SMS_NOTIFICATION_ACTION_TYPE.getAllSuccess]: {
					context: SMS_NOTIFICATION_ACTION_TYPE.getAllSuccess,
					scope: MessageScopeType.Local,
					type: MessageType.Success,
					messageCode: SMS_NOTIFICATIONS_MESSAGE_CODES.success.getAllSuccess,
				},
				[SMS_NOTIFICATION_ACTION_TYPE.updateSuccess]: {
					context: SMS_NOTIFICATION_ACTION_TYPE.updateSuccess,
					scope: MessageScopeType.Local,
					type: MessageType.Success,
					messageCode: SMS_NOTIFICATIONS_MESSAGE_CODES.success.updateSuccess,
				},
			})
		)
	);

	constructor(
		private actions$: Actions,
		private action: SmsNotificationSettingsAction,
		private service: SmsNotificationSettingsService,
		private messageService: MessageService
	) {}
}
